const updates = [
  {
    time: '10分钟前',
    tag: '热搜',
    title: '创造营2026三公舞台完整排名出炉，黑马选手逆袭进前三',
    summary: '第三轮公演结束后排名大洗牌，原定C位选手意外跌出前五，训练生林某以一支原创舞蹈惊艳全场评委。',
  },
  {
    time: '28分钟前',
    tag: '独家',
    title: '电竞世界杯中国区预选赛突现黑马战队，小组赛全胜晋级',
    summary: '一支名不见经传的新锐战队以全胜战绩从死亡之组突围，其战术体系引发圈内热议，多支豪门已启动接触。',
  },
  {
    time: '1小时前',
    tag: '快讯',
    title: '《歌手2026》第六期录制现场突发状况，导演组紧急调整赛制',
    summary: '原定踢馆歌手因健康原因临时退出，节目组启用替补方案，新增一轮复活赛环节，选手反应各异。',
  },
  {
    time: '2小时前',
    tag: '爆料',
    title: '年度街舞大赛裁判评分引争议，多位选手公开质疑打分公正性',
    summary: '半决赛结束后社交平台出现大量讨论，有选手晒出训练室视频对比决赛表现，评分标准再成焦点。',
  },
  {
    time: '3小时前',
    tag: '热榜',
    title: 'AI创作大赛结果揭晓，00后团队作品惊艳全场获百万奖金',
    summary: '选手使用AI工具辅助创作的短片在国际评审团中获得全票通过，引发关于创作边界的大讨论。',
  },
  {
    time: '5小时前',
    tag: '更新',
    title: '美食大赛全国总决赛阵容确认，往届冠军与新晋网红正面交锋',
    summary: '三季冠军得主宣布回归赛场，将与人气最高的短视频创作者展开一场传统与创新的料理对决。',
  },
  {
    time: '8小时前',
    tag: '专题',
    title: '本周大赛吃瓜回顾：十大名场面一次看完，你最Pick哪一个',
    summary: '从选秀舞台到电竞赛场，本周各大比赛名场面合集，精彩瞬间不容错过，文末附完整回放入口。',
  },
];

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">
              每日快讯
            </h2>
            <p className="text-sm text-foreground-500 mt-2">大赛吃瓜动态实时更新，最新爆料第一时间送达</p>
          </div>
          <span className="hidden sm:flex items-center gap-2 text-sm text-accent-600 whitespace-nowrap">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            实时更新中
          </span>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-[2px] bg-background-200"></div>
          <div className="flex flex-col gap-6">
            {updates.map((item, i) => (
              <div key={i} className="relative flex gap-5 pl-1">
                <div className="relative z-10 w-10 h-10 rounded-full bg-background-50 border-2 flex items-center justify-center flex-shrink-0 mt-0.5"
                  style={{ borderColor: i === 0 ? 'oklch(var(--primary-500))' : 'oklch(var(--background-200))' }}
                >
                  <div className="w-3 h-3 rounded-full"
                    style={{ backgroundColor: i === 0 ? 'oklch(var(--primary-500))' : 'oklch(var(--secondary-400))' }}
                  ></div>
                </div>
                <div className="flex-1 bg-background-100 rounded-xl p-4 md:p-5">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className={`px-2 py-0.5 rounded-full text-[11px] font-medium whitespace-nowrap ${
                      item.tag === '热搜' ? 'bg-primary-100 text-primary-600' :
                      item.tag === '独家' ? 'bg-accent-100 text-accent-700' :
                      'bg-secondary-100 text-secondary-600'
                    }`}>
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                  </div>
                  <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-1.5">{item.title}</h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.summary}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}